import { render, staticRenderFns } from "./lostpassword.page.vue?vue&type=template&id=e51014ec&scoped=true&"
import script from "./lostpassword.page.vue?vue&type=script&lang=js&"
export * from "./lostpassword.page.vue?vue&type=script&lang=js&"
import style0 from "./lostpassword.page.vue?vue&type=style&index=0&id=e51014ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51014ec",
  null
  
)

export default component.exports